import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Box from "@material-ui/core/Box";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TelegramIcon from "@material-ui/icons/Telegram";

const useStyles = makeStyles((theme) => ({
    containerCol: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    containerRow: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btn_fps: {
        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        borderRadius: 5,
        border: 0,
        color: 'white',
        width: '270px',
        height: '50px',
        fontSize: '12pt',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
    },
    btn_turnir: {
        background: 'linear-gradient(9deg, rgba(255,102,0,1) 0%, rgba(255,201,0,1) 100%)',
        borderRadius: 5,
        border: 0,
        color: 'white',
        width: '270px',
        height: '50px',
        fontSize: '12pt',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(254, 234, 215, 100)',
    },
}));

const ModeGame = ({ open, onChange }) => {

    const classes = useStyles();

    return (
        <Dialog aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">
                <Box className={classes.containerRow}>
                    ВЫБЕРИ РЕЖИМ
                </Box>
                <Box className={classes.containerCol} style={{ marginTop: '1.0rem' }}>
                    <Typography align={'center'}> 1. Измеряй мощность своего телефона с помощью зайцев </Typography>
                    <Button onClick={() => { onChange(0) }} className={classes.btn_fps} size="large" variant="contained" color="primary" style={{ marginTop: '0.9rem' }}>
                        Мощность по FPS
                    </Button>
                    <Typography align={'center'} style={{ marginTop: '1.2rem' }}> 2. Соревнуйся мощностью с другими и получай деньги </Typography>
                    <Button onClick={() => { onChange(1) }} className={classes.btn_turnir} size="large" variant="contained" color="primary" style={{ marginTop: '0.9rem' }}>
                        Онлайн-турнир
                    </Button>
                </Box>
            </DialogTitle>
        </Dialog>
    );
}

ModeGame.propTypes = {
    open: PropTypes.bool.isRequired,
};

export default ModeGame;
